import {
  ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output,
  SimpleChanges, ViewChildren, ViewEncapsulation
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ThemeManagerService } from '~/services/theme-manager';
import { groupBy } from '@progress/kendo-data-query';
import { GridFieldSummary } from '~/models/modules/gridField';
import { ActiveDirectoryIntegrationSettingsService } from '~/services/modules/common/active-directory-integration-settings.service';

@Component({
    selector: 'asap-fields-select-from-boxes',
    templateUrl: './asap-fields-select-from-boxes.html',
    styleUrls: ['./asap-fields-select-from-boxes.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class AsapFieldsSelectFromBoxes implements OnInit, OnChanges {
  // @Input() fields: any[] = [];
  // @Input() selectedFields: any[] = [];
  @Input() primaryField: any;
  @Input() displayFieldName: string = 'name';
  @Input() title: string = 'Vendor';
  @Input() fullWidth: boolean = false;
  @Input() max10Items: boolean = false;
  @Input() showFilters: boolean = false;
  @Input() withPrimary: boolean = false;
  @Input() withCustomCheckBox: boolean = false;
  @Input() disabled: boolean = false;
  @Input() FromBarcodeEditLabel: boolean = false;
  @Output() selectedFieldsOutput: EventEmitter<any> = new EventEmitter();
  @Output() primaryCheckOutput: EventEmitter<any> = new EventEmitter();
  @Output() customCheckBoxOutput: EventEmitter<any> = new EventEmitter();
  @Output() customADCheckBoxOutput: EventEmitter<any> = new EventEmitter();

  @ViewChildren("primaryCheck") primaryChecks: ElementRef[];
  @ViewChildren("customCheckBoxes") customCheckBoxes: ElementRef[];
  _theme: string;
  _form: FormGroup;
  // _fieldsFiltered: any[];
  filter1: string = '';
  filter2: string = '';
  _selectedFieldsFiltered: any[];
  _selectedColumns: any[] = [];
  _groupedDataFields: any[];
  _groupedDataSelectedFields: any[];
  editForm: FormGroup;
  _CustomCheckedFields: GridFieldSummary[] = [];
  _aDCustomCheckedFields: GridFieldSummary[] = [];

  constructor(private _themeManager: ThemeManagerService,
    private _fb: FormBuilder,
    private adIntegrationSettingsService: ActiveDirectoryIntegrationSettingsService) {
    this.editForm = this._fb.group({
      groupHeader: new FormControl(null),
      selectedFields: new FormControl(null, Validators.required),
    });

    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
  }

  @Input()
  get fields() { return this.fieldsCopy; }
  set fields(x: any) {
    if (x && x.length > 0) {
      this.fieldsCopy = [...x];
      this._groupedDataFields = groupBy(this.fieldsCopy, [{ field: 'columnsGroup.name' }]);
    } else {
      this.fieldsCopy = [];
      this._groupedDataFields = [];
    }
  }

  @Input()
  get selectedFields() { return this.selectedFieldsCopy; }
  set selectedFields(x: any) {
    if (x && x.length > 0) {
      this.selectedFieldsCopy = [...x];
      this._groupedDataSelectedFields = groupBy(this.selectedFieldsCopy, [{ field: 'columnsGroup.name' }]);
    } else {
      this.selectedFieldsCopy = [];
      this._groupedDataSelectedFields = [];
    }
  }

  fieldsCopy: any[] = [];
  selectedFieldsCopy: any[] = [];

  ngOnInit() {
    this._selectedFieldsFiltered = this.selectedFieldsCopy;

    if (this.selectedFieldsCopy && this.selectedFieldsCopy.length > 0) {
      this.selectedFieldsCopy.forEach((element) => {
        var findElement = this.fieldsCopy.find((f: any) => f.id == element.id);

        if (findElement) {
          if (!this.FromBarcodeEditLabel)
            this.fieldsCopy.splice(this.fields.indexOf(findElement), 1);
        }
      });

      this.GroupFieldsAndSelectedFields(this.fieldsCopy, this.selectedFieldsCopy);
    }

    this.adIntegrationSettingsService.isImportActiveDirectoryAccounts.subscribe((response: any) => {
      if (response == false) {
        this.customCheckBoxes.forEach(x => { x.nativeElement.checked = false; });
      }
    });
  }

  GroupFieldsAndSelectedFields(Fields: any, SelectedFields: any) {
    this._groupedDataFields = [];
    this._groupedDataSelectedFields = [];
    if (Fields && Fields.length > 0) {
      this._groupedDataFields = groupBy(Fields, [{ field: 'columnsGroup.name' }]);
    }

    if (SelectedFields && SelectedFields.length > 0) {
      this._groupedDataSelectedFields = groupBy(SelectedFields, [{ field: 'columnsGroup.name' }]);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    //if(changes.selectedFields.currentValue.length == 0)
    //this.selectedFieldsCopy = [...changes.selectedFields.currentValue];

  }

  readFilteredFields(idx: number) {
    let resultArr = [];
    if (idx == 1) {
      if (this.filter1) {
        resultArr = this.fieldsCopy.filter((res) => {
          if (res[this.displayFieldName]) {
            return (res[this.displayFieldName].toLowerCase().indexOf(this.filter1.toLowerCase()) !== -1);
          }

          return true;
        });
      }
      else {
        resultArr = this.fieldsCopy;
      }
    }
    else {
      if (this.filter2) {
        resultArr = this.selectedFieldsCopy.filter((res) => {
          if (res[this.displayFieldName]) {
            return (res[this.displayFieldName].toLowerCase().indexOf(this.filter2.toLowerCase()) !== -1);
          }

          return true;
        });
      }
      else {
        resultArr = this.selectedFieldsCopy;
      }
    }

    this.GroupFieldsAndSelectedFields(this.fieldsCopy, this.selectedFieldsCopy);
    return resultArr;
  }

  readFilteredFieldsGrouped(idx: number, fields: any) {
    let resultArr = [];

    if (idx == 1) {
      if (this.filter1) {
        resultArr = fields.filter((res: any) => {
          if (res[this.displayFieldName]) {
            return (res[this.displayFieldName].toLowerCase().indexOf(this.filter1.toLowerCase()) !== -1);
          }

          return true;
        });
      }
      else {
        resultArr = fields;
      }
    }
    else {
      if (this.filter2) {
        resultArr = fields.filter((res: any) => {
          if (res[this.displayFieldName]) {
            return (res[this.displayFieldName].toLowerCase().indexOf(this.filter2.toLowerCase()) !== -1); return true;
          }
        });
      }
      else {
        resultArr = fields;
      }
    }
    //this.GroupFieldsAndSelectedFields(this.fields, this.selectedFields);

    return resultArr;
  }

  _selectedFilterInput(e: any) {
    if (e && e.srcElement) {
      this._selectedFieldsFiltered = this.selectedFieldsCopy.filter((res) => {
        if (res[this.displayFieldName]) {
          return res[this.displayFieldName].includes(e.srcElement.value);
        }

        return false;
      });
    }
  }

  selectedItems: any[];

  public toggleSelection(event: any, item: any) {
    var select: boolean = false;

    if (!this.disabled) {
      const multiSelect = event.ctrlKey;
      const multiSelectShift = event.shiftKey;

      if (multiSelect) //multiselect
      {
        if (item.isSelected != undefined) {
          if (item.isSelected != undefined) {
            select = true;
            item.isSelected = !item.isSelected
          }
          else {
            select = true;
            item.isSelected = true;
          }
        }
      }
      else if (multiSelectShift) //multiselect
      {
        if (item.isSelected != undefined) {
          if (item.isSelected != undefined) {
            if (this.selectedFieldsCopy.includes(item)) {
              var start = this.readFilteredFields(2).indexOf(this.GetCurrentSelected(this.readFilteredFields(2)));
              var end = this.readFilteredFields(2).indexOf(item);
              this.selectedItems = this.readFilteredFields(1).slice(Math.min(start, end), Math.max(start, end) + 1);
              this.selectedItems.forEach(e => {
                const index = this.fieldsCopy.findIndex(x => x.id == e.id);
                this.readFilteredFields(2)[index].isSelected = true;
              });
            }

            var start = this.readFilteredFields(1).indexOf(this.GetCurrentSelected(this.readFilteredFields(1)));
            var end = this.readFilteredFields(1).indexOf(item);
            this.selectedItems = this.readFilteredFields(1).slice(Math.min(start, end), Math.max(start, end) + 1);
            this.selectedItems.forEach(e => {
              const index = this.fieldsCopy.findIndex(x => x.id == e.id);
              this.fieldsCopy[index].isSelected = true;
            });
          }
        }
      }
      else {
        this.unselectAll((this.readFilteredFields(1)));
        this.unselectAll((this.readFilteredFields(2)));
        item.isSelected = true;
      }
    }

    this.GroupFieldsAndSelectedFields(this.fieldsCopy, this.selectedFieldsCopy);
  }

  unselectAll(list: any) {
    list.forEach((element: any) => {
      element.isSelected = false;
    });
  }

  GetCurrentSelected(list: any): any {
    var item: any;

    list.forEach((element: any) => {
      if (element.isSelected) {
        item = element;
      }
    });

    return item;
  }

  public moveSelected(direction: any) {
    if (direction === 'left') {
      this.selectedFieldsCopy.forEach((item: any) => {
        if (item.isSelected) {
          if (item.id == this.primaryField?.id) {
            this.primaryField = null;
            this.primaryCheckOutput.emit(this.primaryField);
          }

          this.fieldsCopy.push(item);
          // var gpheader = [];
          // gpheader = this.editForm.controls.groupHeader.value;
          // gpheader.splice(gpheader.findIndex((x: any) => x.id == item.id), 1);
          // this.editForm.controls.groupHeader.setValue(gpheader);
          this._selectedColumns.splice(this._selectedColumns.findIndex((x) => x.id == item.id), 1);
        }
      });

      this.selectedFieldsCopy = this.selectedFieldsCopy.filter((i: any) => !i.isSelected);
    }
    else {
      this.fieldsCopy.forEach((item: any) => {
        if (item.isSelected) {
          this.selectedFieldsCopy.push(item);
        }
      });

      this.fieldsCopy = this.fieldsCopy.filter((i: any) => !i.isSelected);
    }

    this.editForm.patchValue({
      selectedFields: this.selectedFieldsCopy,
    });

    this.fieldsCopy.forEach(field => {
      field.isSelected = false;
    });

    this.selectedFieldsCopy.forEach(field => {
      field.isSelected = false;
    });

    this.selectedFieldsOutput.emit(this.selectedFieldsCopy);
    this.GroupFieldsAndSelectedFields(this.fieldsCopy, this.selectedFieldsCopy);
  }

  public verticalMove(direction: any) {
    var index = -1;
    var newIndex = -1;

    var currentSelectedField = this.selectedFieldsCopy.filter((i: any) => i.isSelected);

    if (currentSelectedField.length == 0) return;

    var firstItemIndex = this.selectedFieldsCopy.findIndex((x: any) => x[this.displayFieldName] === currentSelectedField[0][this.displayFieldName]);
    var lastItemIndex = this.selectedFieldsCopy.findIndex((x: any) => x[this.displayFieldName] === currentSelectedField[currentSelectedField.length - 1][this.displayFieldName]);

    if (direction === 'up' && firstItemIndex > 0) {
      currentSelectedField.forEach((item: any) => {
        index = this.selectedFieldsCopy.findIndex((x: any) => x[this.displayFieldName] === item[this.displayFieldName]);
        newIndex = index - 1;

        this.selectedFieldsCopy = this.selectedFieldsCopy.filter((i: any) => i[this.displayFieldName] != '');
        if (newIndex < this.selectedFieldsCopy.length - 1 || newIndex > 0) {
          this.selectedFieldsCopy.splice(newIndex, 0, this.selectedFieldsCopy.splice(index, 1)[0]);
        }
      });
    }
    else if (direction === 'down' && lastItemIndex < this.selectedFieldsCopy.length - 1) {
      for (let i = currentSelectedField.length - 1; i >= 0; i--) {
        index = this.selectedFields.findIndex((x: any) => x[this.displayFieldName] === currentSelectedField[i][this.displayFieldName]);
        newIndex = index + 1;

        this.selectedFieldsCopy = this.selectedFieldsCopy.filter((x: any) => x[this.displayFieldName] != '');

        if (newIndex < this.selectedFieldsCopy.length - 1 || newIndex > 0) {
          this.selectedFieldsCopy.splice(newIndex, 0, this.selectedFieldsCopy.splice(index, 1)[0]);
        }
      }
    }

    this.selectedFieldsOutput.emit(this.selectedFieldsCopy);
    this.GroupFieldsAndSelectedFields(this.fieldsCopy, this.selectedFieldsCopy);
  }
  //#region  moveAll
  public moveAll(direction: any) {
    if (!this.disabled) {
      if (direction === 'right') {
        this.selectedFieldsCopy = [...this.selectedFieldsCopy, ...this.fieldsCopy];
        this.fieldsCopy = [];
      }
      else {
        this.fieldsCopy = [...this.fieldsCopy, ...this.selectedFieldsCopy];
        this.selectedFieldsCopy = [];
        this._selectedColumns = [];
        this.editForm.controls.groupHeader.setValue([]);
        this.primaryField = null;
        this.primaryCheckOutput.emit(this.primaryField);
      }

      this._updateSelectedFieldsForGrouping();
      this.selectedFieldsOutput.emit(this.selectedFieldsCopy);
      this.GroupFieldsAndSelectedFields(this.fieldsCopy, this.selectedFieldsCopy);
    }
  }
  //#endregion

  _updateSelectedFieldsForGrouping() {
    this.editForm.patchValue({
      selectedFields: this.selectedFields,
    });
  }

  onPrimaryClick(event: any, field: any) {
    event.stopPropagation();

    if (event.target.checked) {
      this.primaryChecks.forEach(x => { if (event.target != x.nativeElement) x.nativeElement.checked = false; });
      this.primaryField = field;
    }
    else {
      this.primaryField = null;
    }

    this.primaryCheckOutput.emit(this.primaryField);
  }

  onCustomCheckBoxClick(event: any, field: any) {
    event.stopPropagation();

    if (event.target.checked) {
      this._CustomCheckedFields.push(field);
      field.isChecked = true;
      this._aDCustomCheckedFields.push(field);
      this.customADCheckBoxOutput.emit(this._aDCustomCheckedFields)
    }
    else {
      field.isChecked = false;
      this._aDCustomCheckedFields.push(field);
      this.customADCheckBoxOutput.emit(this._aDCustomCheckedFields);

      this.customCheckBoxes.forEach(x => { if (event.target == x.nativeElement) x.nativeElement.checked = false; });
      var FieldIndex = this._CustomCheckedFields.indexOf(field);

      if (FieldIndex != -1) {
        this._CustomCheckedFields.splice(FieldIndex, 1);
      }
    }

    this.customCheckBoxOutput.emit(this._CustomCheckedFields);
  }
}
